import React, { useCallback } from 'react';

import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import gStyles from 'config/styles';

import { selectLayoutConfig } from 'store/config/selectors';
import { getChannels } from 'store/programs/selectors';
import { RBChannel } from 'store/railsBuilder/reducer.types';

import useHeaderConfig from 'utils/hooks/useHeaderConfig';
import { isWeb } from 'utils/responsiveness';

import WebHeader from 'screens/Settings/components/WebHeader';
import { SETTINGS_CHANNEL_LINEUP_STANDARD_LIST } from 'screens/Settings/languagesConst';

import { ImageSize } from 'components/NagraImage/types';
import ChannelCard from 'components/Ribbon/components/ChannelCard/ChannelCard';

import styles from './styles';

function StandardList() {
    const { t } = useTranslation();

    useHeaderConfig({ isRoot: isWeb, disableFocusOnMount: true });

    const { background } = useSelector(selectLayoutConfig);
    const channels = useSelector(getChannels);

    const renderItem = useCallback(
        ({ item }: ListRenderItemInfo<RBChannel>) => (
            <ChannelCard
                item={item}
                style={styles.container}
                logoStyle={styles.logo}
                width={ImageSize.SETTINGS_LIST_CHANNEL_LOGO.width}
                height={ImageSize.SETTINGS_LIST_CHANNEL_LOGO.height}
                isTitleVisible
                accessibilityRole="menuitem"
                isOnSettingsPage
            />
        ),
        [],
    );

    return (
        <>
            {isWeb && (
                <WebHeader title={t(SETTINGS_CHANNEL_LINEUP_STANDARD_LIST)} />
            )}
            <View
                style={[
                    gStyles.settingsContainer,
                    { backgroundColor: background },
                ]}
            >
                <FlatList
                    data={channels}
                    keyExtractor={keyExtractor}
                    style={[
                        gStyles.settingsContentContainer,
                        { backgroundColor: background },
                    ]}
                    snapToAlignment="start"
                    decelerationRate="fast"
                    renderItem={renderItem}
                    showsHorizontalScrollIndicator={false}
                    keyboardDismissMode="on-drag"
                    overScrollMode="never"
                    bounces={false}
                    accessibilityRole="menu"
                />
            </View>
        </>
    );
}

export default StandardList;

function keyExtractor(item: RBChannel) {
    return item.editorial.id;
}
